import React ,{useState}from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DescriptionIcon from '@material-ui/icons/Description';
import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AppsIcon from '@material-ui/icons/Apps';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import { Box, Avatar, Divider, List, ListItem, ListItemText, ListItemIcon, Drawer } from '@material-ui/core';
import avatar from '../../images/avatar.jpg'
import { Link, NavLink } from 'react-router-dom';
import myresume from '../../Data/ResumeOfMd_Asikur_Rahaman.pdf'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
        color: "tomato",
    },
    title: {
        flexGrow: 1,
        color: "tomato",
    },
    bg: {
        background: "#222",
    },
    menuSideBarContainer: {
        width: 250,
        height: "100%",
        background: "#511",
    },
    avatar: {
        display: "block",
        margin: ".5rem auto",
        width: theme.spacing(13),
        height: theme.spacing(13)
    },
    listColor:{
        color:"tan",
    },
    listColorDownload: {
        color: "tan!important",
    },


}));

const menuItems = [
    {
        listIcons: <HomeIcon />,
        listText: 'Home',
        link:"/"
    },
    {
        listIcons: <AssignmentIndIcon />,
        listText: 'Resume',
        link:"/resume"
    },
    {
        listIcons: <AppsIcon />,
        listText: 'Portfolio',
        link:"/portfolio"
    },
    {
        listIcons: <DescriptionIcon />,
        listText: 'Blog',
        link:"/blog"
    },
    {
        
        listIcons: <ContactMailIcon />,
        listText: 'Contact Me',
        link:"/contact"
    },
]

const NavBar = () => {
    const classes = useStyles();
    const [navBar, setNavBar] = useState({
        right:false
    });

    const sideBarToggle = (slider, open) => () => {
        
        setNavBar({ ...navBar, [slider]: open });
      };

    const navSideBar = (slider) => (
        <Box onClick={sideBarToggle("right", false)} className={classes.menuSideBarContainer} component="div">
                <Avatar className={classes.avatar} src={avatar} alt="Md Asikur Rahaman" />
                <Divider />

                <List component="nav">

                    {
                        menuItems.map((menuItem, key) => (
                            <ListItem button key={key} component={Link} to={menuItem.link}>
                                <ListItemIcon className={classes.listColor}>
                                    {menuItem.listIcons}
                                </ListItemIcon>
                                <ListItemText className={classes.listColor}>
                                    {menuItem.listText}
                                </ListItemText>
                            </ListItem>
                        ))
                    }

                <ListItem button >
                    <ListItemIcon className={classes.listColor} >
                       <CloudDownloadIcon/>
                    </ListItemIcon>
                    <ListItemText  >
                        <NavLink className={classes.listColorDownload} to={`${myresume}`} target="_blank" download>Download Resume</NavLink>
                    </ListItemText>
                </ListItem>


                </List>

            </Box>
   )

    return (
        <React.Fragment>
            
            <div className={classes.root}>
                <AppBar position="static" className={classes.bg}>
                    <Toolbar>
                        <IconButton onClick={sideBarToggle("right", true)} edge="start" className={classes.menuButton} aria-label="menu">
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                           Asikur - Portfolio
                    </Typography>
                    </Toolbar>
                </AppBar>
                <Drawer 
                anchor="left" 
                open={navBar.right}
                onClose={sideBarToggle("right", false)}
                >
                    {navSideBar('right')}
                </Drawer>
            </div>
        </React.Fragment>

    );
};

export default NavBar;